export const ReportTableField = [
  { key: "_counter", label: "No" },
  { key: "name", label: "Report Name" },
  { key: "category", label: "Category" },
  { key: "_actions", label: "Actions" },
]

export const ProspectTableField = [
  { key: "_counter", label: "No" },
  { key: "converter", label: "Converter" },
  { key: "address", label: "Address" },
  { key: "commodity", label: "Komoditi" },
  { key: "application", label: "Aplikasi" },
  { key: "status", label: "Status" },
  { key: "_actions", label: "Actions" },
]

export const FEEDBACK_COMPLAINT_TABLE_FIELD = [
  { key: "id", label: "ID" },
  { key: "date_time", label: "Date and Time" },
  { key: "issue", label: "Issue" },
  { key: "customer", label: "Customer" },
  { key: "grade", label: "Grade" },
  { key: "lot_no", label: "Lot Number" },
  { key: "end_product_application", label: "End Product Application" },
  { key: "assigned_to", label: "Assigned to" },
  { key: "status", label: "Status" },
  { key: "detail_status", label: "Detail Status" },
  { key: "_actions", label: "Actions" },
]

export const DASHBOARD_ONGOING_SCHEDULE = [
  { key: "_counter", label: "No" },
  { key: "schedule_type", label: "Schedule Type" },
  { key: "about", label: "About" },
  { key: "participants", label: "Participants" },
  { key: "start_datetime", label: "Start Date and Time" },
  { key: "end_datetime", label: "End Date and Time" },
  { key: "invited_by", label: "Created by" },
  { key: "status", label: "Status" },
  { key: "_actions", label: "Actions" },
]

export const DASHBOARD_SUMMARY_FNC_OUTSTANDING = [
  { key: "periode", label: "Periode" },
  { key: "customer", label: "Customer" },
  { key: "grade", label: "Grade" },
  { key: "lot", label: "Lot" },
  { key: "end_product", label: "End Product Application" },
  { key: "issue", label: "Issue" },
  { key: "status", label: "Status" },
]
